import { observer } from 'mobx-react-lite';
import { InboxController } from '../../features/Inbox';

function InboxPage() {
	return <InboxController />;
}

const InboxPageComponent = observer(InboxPage);
export default InboxPageComponent;
